@if (!isLoading) {
  <div class="main-container" data-cy="ar-discount">
    <div class="main-header" data-cy="ar-discount-header">
      Edit discounts
    </div>
    <div class="header-container" data-cy="ar-discount-subheader">
      <div class="ledger-item-detail ledger-item-detail-header" data-cy="ar-discount-header-code">
        Code
      </div>
      <div class="ledger-item-detail ledger-item-detail-header" data-cy="ar-discount-header-price">
        Price
      </div>
      <div class="ledger-item-detail ledger-item-detail-header" data-cy="ar-discount-header-type">
        Discount Type
      </div>
      <div class="ledger-item-detail ledger-item-detail-header" data-cy="ar-discount-header-discount">
        Discount
      </div>
      <div class="ledger-item-detail ledger-item-detail-header" data-cy="ar-discount-header-adj-price">
        Adj. Price
      </div>
    </div>
    <div class="flex-container" data-cy="ar-discount-content">
      <div class="ledger-item-detail" data-cy="ar-discount-code">
        {{ ledgerItem.dataARTransactionItem.dataPatientCaseWorkItem.cfgCaseProcedure.Code }}
      </div>
      <div class="ledger-item-detail" data-cy="ar-discount-price">
        {{ ledgerItem.Amount | currency }}
      </div>
      <div class="ledger-item-detail" data-cy="ar-discount-type-container">
        <app-validvalueselect validvaluename="enumFeeCoverageCalcType"
          vvplaceholder="Discount Type"
          [(selectedValue)]="ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId"
          selectedValueChange=""
        data-cy="ar-discount-type-select"></app-validvalueselect>
      </div>
      <div class="ledger-item-detail" data-cy="ar-discount-amount-container">
        @if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCoverageTypeAmount) {
          <mat-form-field class="item-amount-input" data-cy="ar-discount-amount-field">
            <mat-label data-cy="ar-discount-amount-label">Amount</mat-label>
            <input matInput type="number" [(ngModel)]="ledgerItem.dataARTransactionItem.DiscountAmount" data-cy="ar-discount-amount-input">
          </mat-form-field>
        }
        @if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCoverageTypePCT) {
          <mat-form-field class="item-amount-input" data-cy="ar-discount-pct-field">
            <mat-label data-cy="ar-discount-pct-label">Amount</mat-label>
            <input matInput type="number" [(ngModel)]="ledgerItem.dataARTransactionItem.DiscountPCT" data-cy="ar-discount-pct-input">
          </mat-form-field>
        }
      </div>
      <div class="ledger-item-detail" data-cy="ar-discount-adjusted-price">
        {{ calcAdjustedPrice(ledgerItem) | currency }}
      </div>
    </div>
    <div class="action-container" data-cy="ar-discount-actions">
      <button class="action-button" (click)="close()" mat-button color="warn" data-cy="ar-discount-cancel-btn">Cancel</button>
      <button class="action-button" (click)="save()" mat-raised-button color="primary" data-cy="ar-discount-save-btn">Save</button>
    </div>
  </div>
}
@if (isLoading) {
  <div class="spinner-container" data-cy="ar-discount-spinner-container">
    <mat-spinner data-cy="ar-discount-spinner"></mat-spinner>
  </div>
}
